module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-404 u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container u-relative u-align-center c-big-title"
  }, [_c('h1', {
    staticClass: "t-font-gameover u-color--white u-uppercase t-text--h2"
  }, [_vm._v(_vm._s(_vm.contentPage.title))]), _vm._v(" "), _c('h2', {
    staticClass: "t-font-gameover u-color--red u-uppercase t-text--lg u-line-height--lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.subtitle)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-y-lg t-text--lg",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.words.or)
    }
  }), _vm._v(" "), _c('app-btn', {
    attrs: {
      "to": _vm.$root.getPageURLFromID('home')
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.actions.backToHome)
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f23d9a"}!./src/scripts/components/page-404/template.html
// module id = 920
// module chunks = 0